module.exports = __webpack_public_path__ + "static/media/icon-weather-conditions.e525c50a.svg";